export default {
  AWS_LAMBDA_GETSIGNEDURL_ENDPOINT: 'https://app5oy8hu1.execute-api.us-east-1.amazonaws.com/dev/blog/upload',
  apiUrl: 'https://app5oy8hu1.execute-api.us-east-1.amazonaws.com/dev',
  region: 'us-east-1',
  identityPoolId: 'us-east-1:bb81dd2d-9cf7-486d-b23c-7f3143e952da',
  userPoolId: 'us-east-1_E7JMBLg1K',
  clientId: '4mj8h7rp959fnoipkld54rvvsi',
}
